module.exports = __webpack_public_path__ + "img/level.b922f7c0.svg";